// import './PayCardModal.less';

export const prefix = 'bm-c-pay-card-modal';

export { default } from './PayCardModal';
